<template>
  <modal ref="modal">
    <template #title>
      Aussendungskanal wählen
    </template>
    <template #content>
      <h2 style="font-weight: 600">News</h2>
      <hr>
      <div class="row">
        <div class="col-md-6" style="padding-left: 20px; padding-right: 20px; padding-bottom: 10px">
          <div class="cc-selector">
            <input id="wordpress" type="radio" name="channel" value="wordpress" v-model="channel"
                   :disabled="channelNames.includes('wordpress')"/>
            <label class="drinkcard-cc wordpress" for="wordpress"></label>
            <p style="padding-top: 10px">Wordpress Blog</p>
          </div>
        </div>
        <div class="col-md-6">
<!--          <div class="cc-selector">-->
<!--            <input id="shopware" type="radio" name="channel" value="shopware" v-model="channel"-->
<!--                   :disabled="channelNames.includes('shopware')"/>-->
<!--            <label class="drinkcard-cc shopware" for="shopware"></label>-->
<!--            <p>Shopware Blog</p>-->
<!--          </div>-->
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" style="text-align: center">
          <div class="cc-selector" style="display: flex; justify-content: center">
            <input id="app" type="radio" name="channel" value="mobileApp" v-model="channel"
                   :disabled="channelNames.includes('mobileApp')"/>
            <label class="drinkcard-cc app" for="app"></label>
          </div>
          <p>App News</p>
        </div>
        <div v-if="hasMagazines" class="col-md-6" style="text-align: center">
          <div class="cc-selector" style="display: flex; justify-content: center">
            <input id="magazine" type="radio" name="channel" value="magazine" v-model="channel"
                   :disabled="channelNames.includes('magazine')"/>
            <label class="drinkcard-cc magazine" for="magazine"></label>
          </div>
          <p>App WKZ-Trendblog</p>
        </div>
      </div>
      <h2 style="font-weight: 600">Posts</h2>
      <hr>
      <div class="row">
        <div class="col-md-6" style="text-align: center">
          <div class="cc-selector" style="display: flex; justify-content: center; padding-top: 15px">
            <input id="instagram" type="radio" name="channel" value="instagram" v-model="channel"
                   :disabled="channelNames.includes('instagram')"/>
            <label class="drinkcard-cc instagram" for="instagram" v-tippy content="Bitte beachten Sie die standardmäßigen Bildmaße der Social Media Platform."></label>
          </div>
            <p>Instagram Post</p>
        </div>
        <div class="col-md-6" style="text-align: center">
          <div class="cc-selector" style="display: flex; justify-content: center; padding-top: 15px">
            <input id="facebook" type="radio" name="channel" value="facebook" v-model="channel"
                   :disabled="channelNames.includes('facebook')"/>
            <label class="drinkcard-cc facebook" for="facebook" v-tippy content="Bitte beachten Sie die standardmäßigen Bildmaße der Social Media Platform."></label>
          </div>
            <p style="padding-top: 11px;">Facebook Post</p>
        </div>
      </div>
    </template>
    <template #footer>
      <button class="btn btn-primary" :disabled="channelNames.includes('magazine')" @click="addNewChannel">Hinzufügen</button>
    </template>
  </modal>
</template>

<script>
import Modal from "../../common/modal/Modal";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: 'ChooseChannelModal',
  components: {Modal},
  props: ['mediaType', 'categories'],
  data() {
    return {
      channel: '',
      channelsArray: []
    }
  },
  mounted() {
  },
  methods: {
    ...mapMutations([
      'addChannel',
      'getBlogCategories'
    ]),
    disabled() {
      return this.channels.includes(this.channel);
    },
    addNewChannel() {
      this.addChannel({mediaType: this.mediaType, channel: this.channel, categories: this.categories});

      if (['wordpress', 'shopware'].includes(this.channel)) {
        this.getBlogCategories();
      }

      let element = this.$refs.modal.$el
      $(element).modal('hide')
      this.channel = ''
    }
  },
  computed: {
    ...mapGetters({
      channels: 'getChannels',
      hasMagazines: 'getHasMagazines',
      channelNames: 'getChannelNames'
    })
  }
}
</script>

<style scoped>
.cc-selector {
  text-align: center;
}

.cc-selector input {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.wordpress {
  background-image: url(/images/logos/wp-logo.png);
  height: 105px !important;
  width: 240px !important;
}

.instagram {
  background-image: url(/images/logos/instagram-logo.png);
  height: 65px !important;
  width: 240px !important;
}

.facebook {
  background-image: url(/images/logos/facebook-logo.png);
  height: 55px !important;
  width: 240px !important;
}

.shopware {
  background-image: url(/images/logos/sw-logo.png);
  height: 70px !important;
  margin-top: 30px
}

.app {
  background-image: url(/images/logos/app.png);
  height: 70px !important;
  width: 130px !important;
  margin-top: 30px
}

.magazine {
  background-image: url(/images/logos/magazin.png);
  height: 70px !important;
  width: 130px !important;
  margin-top: 30px
}

.cc-selector input:active + .drinkcard-cc {
  opacity: .9;
}

.cc-selector input:checked + .drinkcard-cc {
  -webkit-filter: none;
  -moz-filter: none;
  filter: none;
}

.drinkcard-cc {
  cursor: pointer;
  background-size: cover;
  background-repeat: no-repeat;
  display: inline-block;
  width: 100%;
  height: 120px;
  -webkit-transition: all 100ms ease-in;
  -moz-transition: all 100ms ease-in;
  transition: all 100ms ease-in;
  -webkit-filter: brightness(1.8) grayscale(1) opacity(.7);
  -moz-filter: brightness(1.8) grayscale(1) opacity(.7);
  filter: brightness(1.8) grayscale(1) opacity(.7);
}

.drinkcard-cc:hover {
  -webkit-filter: brightness(1.2) grayscale(.5) opacity(.9);
  -moz-filter: brightness(1.2) grayscale(.5) opacity(.9);
  filter: brightness(1.2) grayscale(.5) opacity(.9);
}

/* Extras */
a:visited {
  color: #888
}

a {
  color: #444;
  text-decoration: none;
}

p {
  margin-bottom: .3em;
}
</style>
